<script lang="ts" setup>
import { useProp } from "@/composables";
import { cn } from "@/lib/utils";
const actions = useProp<any[]>("actions");
</script>

<template>
  <div
    :class="cn('px-4 sm:px-6', $attrs.class, $page.props.title ? 'my-4' : '')"
  >
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="font-medium text-lg">
          {{ $page.props.title }}
        </h1>
      </div>
      <div class="mt-4 sm:mt-0 sm:ml-16 flex gap-4">
        <Button
          v-for="action in actions"
          v-bind="action"
        >
          {{ action.title }}
        </Button>
        <slot></slot>
      </div>
    </div>
  </div>
</template>
